import { get } from 'lodash-es';
import useUserContext from './useUserContext';

export default function useIsAuthenticated(defaultValue = false): boolean {
    const state = useUserContext();

    return get(state, 'isAuthenticated', defaultValue);
}
